import {Controller} from "stimulus"

export default class extends Controller {

    connect() {
        console.log("log from parcel-merge controller");
    }

    toggleControl(e) {
        e.target.closest(".merge-action").querySelector(".parcel-select-area").classList.toggle("hidden")
    }

    selectSubsumed(e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        const subsumed = e.target.closest('li').dataset.parcelId;
        const current = JSON.parse(e.target.closest('.search-container').querySelector('.parcel-search-input').dataset.excludedIds);
        const subsumedname = e.target.closest('li').querySelector('.result-primary').innerText
        if (current[0] == subsumed) {
            alert("Existing parcel cannot be merged into itself.")
            return
        }
        if (subsumed.length > 0) {
            if (confirm('Merge parcel ' + subsumedname + ' into this parcel? All associated records will be transferred.')) {
                const parcelId = current[0];
                fetch("/parcels/" + parcelId + "/merge", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                    },
                    body: JSON.stringify({subsumed: subsumed})
                })
                    .then(response => {
                        const isOk = response.ok;
                        return response.text().then(html => ({html, isOk}));
                    })
                    .then(({html, isOk}) => {
                        this.element.querySelector('.parcel-select-area').classList.add("hidden");
                        if (isOk) {
                            document.getElementById('flash-area').innerHTML = "<p class=\"notice\">Parcel Successfully Merged</p>";
                        } else {
                            document.getElementById('flash-area').innerHTML = "<p class=\"alert\">Parcel Merge Failed</p>";
                        }
                    })
                    .catch(() => {
                        this.element.querySelector('.parcel-select-area').classList.add("hidden");
                        document.getElementById('flash-area').innerHTML = "<p class=\"alert\">Parcel Merge Failed</p>";
                    });
            } else {
                e.target.closest('.parcel-select-area').classList.add("hidden");
            }
        }
    }
}
